import { memo, useCallback } from 'react';

import { SearchFieldClearButton } from '~/components/Search/SearchFieldClearButton';
import { useSearchParams } from '~/hooks/search/useSearchParams';

export type PublicShowcaseSearchActionsProps = {
  onClearSearchValue: () => void;
};

export const PublicShowcaseSearchActions = memo(({ onClearSearchValue }: PublicShowcaseSearchActionsProps) => {
  const { search, clearSearch } = useSearchParams();

  const handleClick = useCallback(() => {
    clearSearch();
    onClearSearchValue();
  }, [onClearSearchValue, clearSearch]);

  if (!search) {
    return null;
  }

  return <SearchFieldClearButton data-testid="CLEAR_FILTER_BUTTON" label="Clear" onClick={handleClick} />;
});

PublicShowcaseSearchActions.displayName = 'PublicShowcaseSearchActions';
